import { ShippingPortalParcel } from '@lanterds/types';

export enum PageNames {
    ShippingPortal = 'shippingPortal',
    Transfer = 'transfer',
    Return = 'return',
    ParcelSearch = 'parcelSearch',
    UserManagement = 'userManagement',
    Users = 'users',
    User = 'user',
    Reports = 'reports',
    ReportManagement = 'reportManagement',
    Outbound = 'outbound',
    ShipmentTracker = 'shipmentTracker',
    DeliveryManagement = 'deliveryManagement',
    ParcelDetail = 'parcelDetail',
    Customers = 'customers',
    Admin = 'admin',
}

export const enum SnackbarVariantNames {
    Default = 'default',
    Error = 'error',
    Success = 'success',
    Warning = 'warning',
    Info = 'info',
    Loading = 'loading',
}

export type ShippingPortalFavorite = {
    id?: string;
    labelQuantity: number;
    dealerCount: number;
    name: string;
    parcelsToPrint: ShippingPortalParcel[];
};
